import React from 'react';
import { Permission } from '../../data/models/permission.model';
import { BaseNote } from '../../data/models/provider-note.model';
import { useAppSelector } from '../useAppSelector';
import { useHasPermission } from './useHasPermission';
import * as userSlice from '../../data/user.slice';

export const useCanEditNote = (note: BaseNote): boolean => {
  const [canEditNote, setCanEditNote] = React.useState<boolean>(false);
  const user = useAppSelector(userSlice.selectUserInfo);

  const editSelfPermission: Permission = {
    resource: 'notes',
    action: 'updatebasic',
    scope: 'self',
  };
  const editAllPermission: Permission = {
    resource: 'notes',
    action: 'updatebasic',
    scope: 'all',
  };

  const canEditSelf = useHasPermission(user, editSelfPermission);
  const canEditAll = useHasPermission(user, editAllPermission);

  React.useEffect(() => {
    setCanEditNote(
      canEditAll ||
        (canEditSelf && note.createdByUserID === user.userAccountID),
    );
  }, [canEditAll, canEditSelf]);

  return canEditNote;
};
